<template>
  <div class="product-questions">
    <p class="product-questions__title">
      {{ $t('Frequently asked questions') }}
    </p>

    <ul class="product-questions__list">
      <li v-for="item in questions" :key="item.title" class="product-questions__item">
        <a :href="item.href" target="_blank" class="product-questions__link">
          {{ item.title }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { LANDING_PAGE_URL } from '@/constants'

export default {
  name: 'ProductPageQuestions',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    questions() {
      return [
        {
          title: this.$t('Delivery terms'),
          href: `${LANDING_PAGE_URL}/faq/dostavka/`,
        },
        {
          title: this.$t('footer.returnPolicy'),
          href: `${LANDING_PAGE_URL}/faq/vozvraty-i-otmeny/`,
        },
        {
          title: this.$t('footer.paymentMethod'),
          href: `${LANDING_PAGE_URL}/faq/oplata/`,
        },
        {
          title: this.$t('footer.refund'),
          href: `${LANDING_PAGE_URL}/faq/oplata/`,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.product-questions {
  background-color: $White;
  padding: 12px;
  display: grid;
  gap: 8px;
  border-radius: 4px;

  @include media-breakpoint-up(xl) {
    gap: 10px;
    padding: 20px 16px;
    border-radius: 8px;
  }

  &__title {
    font-size: 14px;
    line-height: 1;
    font-weight: 600;

    @include media-breakpoint-up(xl) {
      font-size: 16px;
      line-height: 18px;
    }
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    row-gap: 8px;
    color: $GreenM;
    font-size: 13px;
    line-height: 1.2;

    @include media-breakpoint-up(xl) {
      row-gap: 12px;
      font-size: 14px;
      line-height: 16px;
    }
  }

  &__item {
    > a {
      font: inherit;
      color: inherit;
      text-decoration: underline;
    }
  }
}
</style>
